import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './TodoAppointmentsTable.html?raw';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { ExpandableSectionMarkings } from "../../moreCore/UI/Container/ExpandableSectionTypes";
import { SelectEntityDialogTypes } from "../../moreCore/_loadingHelpers/SelectEntityDialog";
import { ContextEntityTodoAppointment, TodoAppointment, TodoAppointmentSEDMode, TodoDescriptionTodoAppointments, TodoPackageTodoAppointments } from "./TodoAppointmentsTypes";
import ExpandableSection from '../../moreCore/UI/Container/ExpandableSection';
import StaticTable from '../../moreCore/UI/StaticTable/StaticTable';
import EntityStore from '../../moreCore/Tools/EntityStore';
import lang from 'dojo/_base/lang';
import FloatingMenu from '../../moreCore/UI/Floating/Menu';
import _GlobalSelectEntityDialogsMixin from '../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import TodoAppointmentsEditor from './TodoAppointmentsEditor';

class TodoAppointmentsTable extends compose(_WidgetBaseSP, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    private contextEntity: ContextEntityTodoAppointment;

    private todoAppointmentsExpander: MdsLax<InstanceType<typeof ExpandableSection>>;
    private tableContainer: HTMLDivElement;
    private todoAppointmentsTable: MdsLax<InstanceType<typeof StaticTable>>;
    private todoAppointmentsStore: MdsLax<InstanceType<typeof EntityStore<TodoAppointment>>>;

    private todoAppointmentsMenuButton: HTMLButtonElement;


    private setContextEntity(entity: ContextEntityTodoAppointment) {
        this.contextEntity = entity;
    }

    private addTodoAppointments(todoAppointments: Array<TodoAppointment>) {
        this.todoAppointmentsStore.addEntries(todoAppointments);
    }

    setData(data: Array<TodoAppointment>, contextEntity: ContextEntityTodoAppointment) {
        if (data) this.todoAppointmentsStore.setup(data);
        this.setContextEntity(contextEntity);

        this.todoAppointmentsExpander.setMarking(data?.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
    }

    private tableRowLayout: StaticTable.RowConfig = {
        attributes: [
            "c_todo_description",
            "ref_todo_description.ref_todo_category.description",
            "due_date",
            "ref_todo_status.description"
        //    "is_my"
        ],
        colNamesInternal: [
            "c_todo_description",
            "ref_todo_description.ref_todo_category.description",
            "due_date",
            "ref_todo_status",
        //    "is_my"
        ],
        bgColors: [
            null,
            null,
            null,
            "ref_todo_status.coloration"
        ],
        txtColors: [
            null,
            null,
            null,
            "ref_todo_status.coloration"
        ],
        headings: [
            (this as any).translate("General_Label_TodoDescription"),
            (this as any).translate("General_Label_TodoCategory"),
            (this as any).translate("General_Label_DueDate"),
            (this as any).translate("General_Label_Status"),
        //    this.translate("TodoAppointments_Label_PersonalTodoEntry")
        ]
    }

    private tableLayout: StaticTable.Layout = {
        label: "todoAppointmentsTable",
        name: "todoAppointmentsTable",
        rows: [(this as any).tableRowLayout],
        enableQuicksearch: true,
        quickSearchProperties: ["c_todo_description"]
    }

    private _tableFormatter(cell: StaticTable.StaticTableCell<TodoAppointment>) {
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;
        let index = cell.tableRow.rowGroup.rowIndex;

        switch (colName) {
            
        }

        return false;
    }

    private _setupTable(): void {
        this.todoAppointmentsTable = new StaticTable();
        this.todoAppointmentsTable.addLayout(this.tableLayout);
        this.todoAppointmentsTable.addDefaultRowActionButton("delete");
        this.todoAppointmentsTable.addDefaultRowActionButton("edit", lang.hitch(this, this._onClickEditButton));
        this.todoAppointmentsTable.setRowClick(lang.hitch(this, this._onClickTableRow));
        this.todoAppointmentsTable.setFormatter(lang.hitch(this, this._tableFormatter));
        this.todoAppointmentsTable.setupFromStore(this.todoAppointmentsStore);
        this.todoAppointmentsTable.setFormatter(lang.hitch(this, this._tableFormatter));
        this.todoAppointmentsTable.setCyAttribute("TodoAppointmentsEditorAppointmentsTable");


        this.todoAppointmentsTable.placeAt(this.tableContainer);
    }

    private _onClickTableRow(e: StaticTable.StaticTableRow<TodoAppointment>) {
        let entity = e.rowGroup.entity;

        this._openEditor(entity);
    }

    private _onClickEditButton(e: StaticTable.StaticTableRowGroup<TodoAppointment>) {
        let entity = e.entity;

        this._openEditor(entity);
    }

    private _openEditor(entity: TodoAppointment) {
        let todoAppointmentEditor = new TodoAppointmentsEditor();
        todoAppointmentEditor.setup(entity);
        todoAppointmentEditor.on("confirmed", lang.hitch(this, this._onEditorConfirmed));
    }

    private _onEditorConfirmed(data: TodoAppointment) {
        this.todoAppointmentsStore.changeEntry(data);
    }

    private _onClickReloadButton(): void {
        this._reload();
    }

    private _reload(): void {
        let requestData = { contextEntity: this.contextEntity };

        this.StandbyStart();
        this.RequestManager.callfunction("Webtool_API__TodoAppointments_GetTodoAppointments", requestData, lang.hitch(this, this._onReloadResponse), lang.hitch(this, this._onReloadError));        
    }


    private _onReloadResponse(response: Array<TodoAppointment>): void {
        this.StandbyStop();
        this.todoAppointmentsStore.setup(response);
        this.emit("reloaded");
    }

    private _onReloadError(error): void {
        console.error(error);
    }

    private _onClickTodoAppointmentsMenuButton(e): void {
        let floatingMenu = new FloatingMenu();
        let icon;

        let storeIsDirty = this.todoAppointmentsStore.isDirty();

        if (storeIsDirty) {
            this.showToast(this.translate("TodoAppointments_Error_StoreDirty"), "fas fa-exclamation-triangle");
            return;
        }

        floatingMenu.addEntry({
            callback: lang.hitch(this, this._onClickMenuEntry, "selectTodoPackage"),
            label: this.translate("TodoAppointments_Label_CreateFromTodoPackageEntry"),
            icon: ""
        });

        floatingMenu.addEntry({
            callback: lang.hitch(this, this._onClickMenuEntry, "selectTodoDescription"),
            label: this.translate("TodoAppointments_Label_CreateFromTodoDescription"),
            icon: ""
        });

        floatingMenu.addEntry({
            callback: lang.hitch(this, this._onClickMenuEntry, "personalAppointment"),
            label: this.translate("TodoAppointments_Label_CreatePersonalTodoEntry"),
            icon: "fas fa-user"
        });

        floatingMenu.open(e, null, "TodoAppointments_Label_CreateTodo" );
    }

    private _onClickMenuEntry(mode: string, e) {
        if (this.todoAppointmentsStore.isDirty()) {
            this.showToast(this.translate("TodoAppointments_Error_StoreDirty"), "fas fa-exclamation-triangle");
            return;
        }

        if (mode === "personalAppointment") {
            this._onClickCreatePersonalTodoEntry(e);
            return;
        }

        this.loadSelectEntityDialog(e, mode, lang.hitch(this, this._onSEDCallback));
    }

    private _onClickTodoPackageEntry(e): void {
        this.loadSelectEntityDialog(e, "selectTodoPackage", lang.hitch(this, this._onSEDCallback));
    }

    private _onClickTodoDescriptionEntry(e): void {
        this.loadSelectEntityDialog(e, "selectTodoDescription", lang.hitch(this, this._onSEDCallback));
    }

    private _onSEDCallback(mode: TodoAppointmentSEDMode, data: Array<string>, items: Array<SelectEntityDialogTypes.Item<TodoPackageTodoAppointments>>) {
        let currentData;
        if (items) currentData = items[0].entry.data;
        else return;

        let requestData;

        switch (mode) {
            case "selectTodoPackage":
                var todoPackage: TodoPackageTodoAppointments = currentData as TodoPackageTodoAppointments;

                requestData = { package: todoPackage, contextEntity: this.contextEntity };
                this.StandbyStart();
                this.RequestManager.callfunction(
                    "Webtool_API__TodoAppointments_AddTodoPackage",
                    requestData,
                    lang.hitch(this, this._onAddPackageResponse),
                    lang.hitch(this, this._onAddPackageError)
                );
                break;
            case "selectTodoDescription":
                let descriptions = [];
                for (let item of items) {
                    currentData = item.entry.data;
                    descriptions.push(currentData);
                }
                //var todoDescription: TodoDescriptionTodoAppointments = currentData as TodoDescriptionTodoAppointments;

                requestData = { descriptions: descriptions, contextEntity: this.contextEntity };
                this.StandbyStart();
                this.RequestManager.callfunction(
                    "Webtool_API__TodoAppointments_AddTodoDescription",
                    requestData,
                    lang.hitch(this, this._onAddDescriptionResponse),
                    lang.hitch(this, this._onAddDescriptionError)
                );
                break;
        }

    }

    private _onAddPackageResponse(response) {
        this.StandbyStop();
        this._onClickReloadButton();
    }

    private _onAddPackageError(error) {
        console.error(error);
    }

    private _onAddDescriptionResponse(response) {
        this.StandbyStop();
        this._onClickReloadButton();
    }

    private _onAddDescriptionError(error) {
        console.error(error);
    }


    private _onClickCreatePersonalTodoEntry(e): void {
        this.StandbyStart();
        let requestData = {
            contextEntity: this.contextEntity
        }
        this.RequestManager.callfunction("Webtool_API__TodoAppointments_AddMyTodo", requestData, lang.hitch(this, this._onAddPersonalTodoResponse), lang.hitch(this, this._onAddPersonalTodoError));

    }

    private _onAddPersonalTodoResponse(response: TodoAppointment) {
        
        this.StandbyStop();

        if (!!response) {
            this._openEditor(response);
        }

        this._reload();
    }

    private _onAddPersonalTodoError(error: more.requestErrorMessage) {
        this.StandbyStop();
        alert(error.Message);
        console.error(error);
    }

    private _onChangeStore(): void {
        var completeList = this.todoAppointmentsStore.getCurrentCompleteList();
        this.todoAppointmentsExpander.setMarking(completeList?.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);

        var todoAppointmentDiffData = this.todoAppointmentsStore.getDiffData();
        this.emit("change", todoAppointmentDiffData);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.todoAppointmentsStore = new EntityStore();
        this.todoAppointmentsStore.on("change", lang.hitch(this, this._onChangeStore));
        this._setupTable();

        this.SEDconfigCallfunction = "Webtool_API__TodoAppointments_GetSEDConfig"
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";
    }
}

export default mdsWidget(TodoAppointmentsTable);